export const roadmappingQueryKeys = {
  roadmap: {
    list: () => ['roadmap', 'list'] as const,
    details: (roadmapId: number) => ['roadmap', roadmapId] as const,
  },
  layout: {
    details: (viewId: number) => ['layout', viewId],
  },
  visualization: {
    all: (viewId: number) => ['visualization', 'list', viewId] as const,
    detail: (viewId: number, visualizationId: number) =>
      ['visualization', 'detail', viewId, visualizationId] as const,
    byType: (viewId: number, type: string) => ['visualization', 'byType', viewId, type] as const,
  },
  swimlaneLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['swimlane-layout', viewId, visualizationId] as const,
    headerConfig: (viewId: number, visualizationId: number, headerFieldId: string) =>
      ['swimlane-layout', 'header-config', viewId, visualizationId, headerFieldId] as const,
  },
  tableLayout: {
    detail: (viewId: number, visualizationId: number) =>
      ['table-layout', viewId, visualizationId] as const,
  },
  publishedVisualization: {
    detail: (viewId: number, visualizationId: number) =>
      ['published-visualization', viewId, visualizationId] as const,
    byToken: (urlToken: string) => ['published-visualization-public', urlToken] as const,
  },
};
